module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "app-main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://m.byr.cn"
    }
  }, [_vm._v("旧版")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.backToNforum()
      }
    }
  }, [_vm._v("电脑版")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://bbs.byr.cn/article/Announce/261"
    }
  }, [_vm._v("客户端")])]), _vm._v(" "), _c('p', [_vm._v(" BYR-team@" + _vm._s(_vm.year) + " ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ced6bc0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 235
// module chunks = 1